import { pull } from 'lodash';

export type Status = 'error' | 'success' | 'info';

export interface Model {
    message: React.ReactNode;
    isOpen: boolean;
    status?: Status;
    surviveNavigation: boolean;
}

type Listener = (popupAlert: Model) => void;

export default class PopupAlert {
    model: Model = {
        message: '',
        isOpen: false,
        status: undefined,
        surviveNavigation: false,
    };
    subscribers: Listener[] = [];

    subscribe(listener: Listener) {
        this.subscribers.push(listener);
    }

    unsubscribe(listener: Listener) {
        pull(this.subscribers, listener);
    }

    setMessage(message: React.ReactNode, status: Status, surviveNavigation = false) {
        this.model = {
            message,
            isOpen: true,
            status,
            surviveNavigation,
        };
        this.notify();
    }

    setSurviveNavigation(s: boolean) {
        this.model = {
            ...this.model,
            surviveNavigation: s,
        };
    }

    setSuccessMessage(message: React.ReactNode, surviveNavigation = false) {
        this.setMessage(message, 'success', surviveNavigation);
    }

    setErrorMessage(message: React.ReactNode, surviveNavigation = false) {
        this.setMessage(message, 'error', surviveNavigation);
    }

    notify() {
        this.subscribers.forEach(s => s(this.getModel()));
    }

    dismiss() {
        this.model = {
            message: '',
            isOpen: false,
            status: undefined,
            surviveNavigation: false,
        };
        this.notify();
    }

    getModel() {
        return this.model;
    }

    isOpen() {
        return this.model.isOpen;
    }
}
